import React, { useEffect, useRef, useState } from "react";
import "./WhyChoose.css";

const WhyChooses = [
  {
    title: "Long Range & Fast Charging",
    desc: "Cover more distance with efficient battery technology.",
    icon: "⚡",
  },
  {
    title: "Low Running Cost",
    desc: "Affordable maintenance and high efficiency.",
    icon: "₹",
  },
  {
    title: "Eco-Friendly Mobility",
    desc: "Zero emissions for a greener future.",
    icon: "🌱",
  },
  {
    title: "Smart Features",
    desc: "App connectivity and advanced controls.",
    icon: "📱",
  },
  {
    title: "Trusted Support",
    desc: "Wide service network across India.",
    icon: "🛠",
  },
  {
    title: "Built for India",
    desc: "Designed to handle Indian roads and weather.",
    icon: "🇮🇳",
  },
];

export default function WhyChoose() {
  const sectionRef = useRef(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect(); // run once
        }
      },
      { threshold: 0.25 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className={`why-container ${show ? "show" : ""}`} ref={sectionRef}>
      <h2 className="why-title animate-title">
        Why Choose <span>UJALA-E-BIKES ?</span>
      </h2>

      <div className="WhyChoose-grid">
        {WhyChooses.map((item, index) => (
          <div
            className="WhyChoose animate-card"
            key={index}
            style={{ transitionDelay: `${index * 0.15}s` }}
          >
            <div className="icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
